import { Device } from '../helpers/Device'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'

export const MOBILE_ADUNIT_ID = 'feed_mobile'
export const DESKTOP_ADUNIT_ID = 'feed_btf'

export class Feed extends Slot {
  _sizes = [[300, 250], 'fluid'] as AdSizes
  lazy = true
  slotName = 'feed'

  constructor(slot: ISlotModel, model: WebModel) {
    super(slot, model)
    this.adUnitId = Device.isMobileOrTablet
      ? MOBILE_ADUNIT_ID
      : DESKTOP_ADUNIT_ID
  }

  template(): string {
    const template = super.template()

    return Device.isMobileOrTablet
      ? `<div class='remove_padding'>
          ${template}
          </div>
      </div>`
      : template
  }
}
